export const ResetAusFindingsTestIds = {
  DU_CHECKBOX: 'reset-aus-findings.du-checkbox',
  DU_INPUT_CHECKBOX: 'reset-aus-findings.du-input-checkbox',
  LP_CHECKBOX: 'reset-aus-findings.lp-checkbox',
  LP_INPUT_CHECKBOX: 'reset-aus-findings.lp-input-checkbox',
};
